import "../achievements/achievements.scss";
import "./borders.scss";
import { useAppSelector } from "../../../hooks/hooks";
import {
  selectLanguage,
  // selectTranslations,
} from "../../../shared/data-access/store/general/generalSlice";
import useAmbientSound from "../../../utils/hooks/use-ambient-sound";
import { AchievementBadge } from "../../ui/achievement-card";
import { selectUser } from "../../../auth/data-access/store/authSlice";

export function BordersPage() {
  const lang = useAppSelector(selectLanguage);
  // const translations = useAppSelector(selectTranslations);
  const user = useAppSelector(selectUser);

  useAmbientSound("home");

  const mockBorders = [
    {
      id: 3,
      name: { en: "Level 3" },
      description: { en: "Reach level 3 to unlock this profile avatar border" },
      image: "/img/avatars-borders/AvatarBorder-lv3.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 3
        : false,
    },
    {
      id: 9,
      name: { en: "Level 9" },
      description: { en: "Reach level 9 to unlock this profile avatar border" },
      image: "/img/avatars-borders/AvatarBorder-lv9.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 9
        : false,
    },
    {
      id: 15,
      name: { en: "Level 15" },
      description: {
        en: "Reach level 15 to unlock this profile avatar border",
      },
      image: "/img/avatars-borders/AvatarBorder-lv15.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 15
        : false,
    },
    {
      id: 21,
      name: { en: "Level 21" },
      description: {
        en: "Reach level 21 to unlock this profile avatar border",
      },
      image: "/img/avatars-borders/AvatarBorder-lv21.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 21
        : false,
    },
    {
      id: 27,
      name: { en: "Level 27" },
      description: {
        en: "Reach level 27 to unlock this profile avatar border",
      },
      image: "/img/avatars-borders/AvatarBorder-lv27.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 27
        : false,
    },
    {
      id: 33,
      name: { en: "Level 33" },
      description: {
        en: "Reach level 33 to unlock this profile avatar border",
      },
      image: "/img/avatars-borders/AvatarBorder-lv33.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 33
        : false,
    },
    {
      id: 39,
      name: { en: "Level 39" },
      description: {
        en: "Reach level 39 to unlock this profile avatar border",
      },
      image: "/img/avatars-borders/AvatarBorder-lv39.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 39
        : false,
    },
    {
      id: 45,
      name: { en: "Level 45" },
      description: {
        en: "Reach level 45 to unlock this profile avatar border",
      },
      image: "/img/avatars-borders/AvatarBorder-lv45.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 45
        : false,
    },
    {
      id: 51,
      name: { en: "Level 51" },
      description: {
        en: "Reach level 51 to unlock this profile avatar border",
      },
      image: "/img/avatars-borders/AvatarBorder-lv51.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 51
        : false,
    },
    {
      id: 56,
      name: { en: "Level 56" },
      description: {
        en: "Reach level 56 to unlock this profile avatar border",
      },
      image: "/img/avatars-borders/AvatarBorder-lv56.svg",
      unlocked: user?.character?.level?.current
        ? user?.character?.level?.current >= 56
        : false,
    },
  ];

  const renderBorders = () => {
    return mockBorders.map((border) => {
      return (
        <AchievementBadge
          key={border.id}
          badgeType={border.unlocked ? "unlocked" : "locked"}
          badge={border.image}
          modalBadgeSlot={
            <div className="avatar-with-border">
              <img
                className="avatar-border-lights"
                src="img/avatar-border-lights.png"
                alt=""
              />
              <img
                src={user?.character.avatar}
                alt=""
                className="avatar-modal"
              />
              <img src={border.image} alt="" className="border-avatar" />
            </div>
          }
          badgeSize={105}
          description={border.description[lang as "en"]}
          subtitle={border.unlocked ? "Unlocked" : undefined}
        >
          {border.name[lang as "en"]}
        </AchievementBadge>
      );
    });
  };

  return (
    <div className="badges-container borders-container">
      <div className="badges-content">
        <div className="achievement-container">{renderBorders()}</div>
      </div>
    </div>
  );
}

export default BordersPage;
